module.exports = __webpack_public_path__ + "static/media/burgerWhite.ac01521a.svg";